import * as actionTypes from "./actions/actionTypes";

const initialState = {
  locations: [],
  activeTab: 0,
  selectedItem: null,
  googlePlaceItem: null,
  mapOptions: {
    clickableIcons: false,
    center: { lat: 33.9103, lng: -118.519291 },
    zoom: 11,
    maxZoom: 19,
    draggable: true,
    panControl: true
  },
  clusters: [],
  resultsShown: false,
  results: [],
  news: [],
  detail: null,
  detailShown: false,
  infoShown: false,
  hasSearched: false,
  hoverId: null,
  mobileMenuShown: false,
  showHelp: false,
  globalAlertShown: false,
  userClosed: false,
  mapFullHeight: false,
  wW: document.documentElement.clientWidth,
  wH: document.documentElement.clientHeight,
  doneLoading: false,
  sort: "default"
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.ADD_ITEM:
      return {
        ...state,
        selectedItem: action.item
      };
    case actionTypes.REMOVE_ITEM:
      return {
        ...state,
        selectedItem: action.item
      };
    case actionTypes.SET_GOOGLE_PLACE_ITEM:
      return {
        ...state,
        googlePlaceItem: action.payload
      };
    case actionTypes.CHANGE_TAB:
      return {
        ...state,
        activeTab: action.index
      };
    case actionTypes.CHANGE_MAP:
      return {
        ...state,
        mapOptions: action.mapOptions
      };
    case actionTypes.SORT_RESULTS:
      return {
        ...state,
        sort: action.sort
      };
    case actionTypes.SAVE_CLUSTERS:
      return {
        ...state,
        clusters: action.clusters
      };
    case actionTypes.SET_RESULTS:
      return {
        ...state,
        results: action.results
      };
    case actionTypes.SHOW_RESULTS:
      return {
        ...state,
        resultsShown: action.bool
      };
    case actionTypes.GET_ALERTS:
      return {
        ...state,
        alerts: action.alerts
      };
    case actionTypes.SET_DETAIL:
      return {
        ...state,
        detail: action.item
      };
    case actionTypes.SHOW_DETAIL:
      return {
        ...state,
        detailShown: action.bool
      };
    case actionTypes.SHOW_INFO:
      return {
        ...state,
        infoShown: action.bool
      };
    case actionTypes.SEARCHED:
      return {
        ...state,
        hasSearched: action.bool
      };
    case actionTypes.SET_HOVER:
      return {
        ...state,
        hoverId: action.id
      };
    case actionTypes.TOGGLE_MENU:
      return {
        ...state,
        mobileMenuShown: action.bool
      };
    case actionTypes.TOGGLE_HELP:
      return {
        ...state,
        showHelp: action.bool
      };
    case actionTypes.SET_WINDOW_SIZE:
      return {
        ...state,
        wW: action.wW,
        wH: action.wH
      };
    case actionTypes.SLIDE_CAROUSEL:
      return {
        ...state,
        slideSelected: action.id
      };
    case actionTypes.SEARCH_IN_PROGRESS:
      return {
        ...state,
        searchIsOpen: action.bool
      };
    case actionTypes.EXPAND_MAP:
      return {
        ...state,
        mapFullHeight: action.bool
      };
    case actionTypes.PREPARE_DATA:
      return {
        ...state,
        locations: action.locations
      };
    case actionTypes.SHOW_GLOBAL_ALERT:
      return {
        ...state,
        globalAlertShown: action.bool
      };
    case actionTypes.USER_CLOSED_NS_MESSAGE:
      return {
        ...state,
        userClosed: action.bool
      };
    case actionTypes.SAVE_MAP:
      return {
        ...state,
        map: action.map
      };
    case actionTypes.SAVE_MAPS:
      return {
        ...state,
        maps: action.maps
      };
    case actionTypes.FETCH_NEWS:
      return {
        ...state,
        news: action.news
      };
    case actionTypes.FETCH_ADS:
      return {
        ...state,
        ad: action.ads
      };
    case actionTypes.FETCH_GRADES:
      return {
        ...state,
        grades: action.grades
      };
    case actionTypes.RECENTER_MAP:
      return {
        ...state,
        mapOptions: action.options
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducer.js